module.exports = __webpack_public_path__ + "img/gov_icon.58f55c5c.png";